// src/utils/projectStatus.js

export const getProjectProgress = (project) => {
    if (project.progress !== undefined) {
        return Math.floor(Number(project.progress));
    }

    const sections = Array.isArray(project.sections) ? project.sections : [];
    const totalSections = sections.length;

    const translatedArr = Array.isArray(project.translatedSections)
        ? project.translatedSections
        : [];
    const translatedCount = translatedArr.filter((t) => t && t.trim().length > 0).length;

    return totalSections > 0 ? Math.floor((translatedCount / totalSections) * 100) : 0;
};

export const getProjectStatus = (project) => {
    if (project.status === 'pre-translating') {
        return 'pre-translating';
    }

    const totalSections = Array.isArray(project.sections) 
        ? project.sections.length 
        : (project.totalSections || 0);

    const translatedCount = Array.isArray(project.translatedSections)
        ? project.translatedSections.filter((t) => t && t.trim().length > 0).length
        : (project.filledTranslations || 0);

    const approvedCount = Array.isArray(project.approvedSections)
        ? project.approvedSections.length
        : (project.approvedCount || 0);

    if (totalSections === 0) {
        return 'in progress';
    }
    if (approvedCount === totalSections) {
        return 'complete';
    }
    if (translatedCount === totalSections) {
        return 'translated';
    }
    return 'in progress';
};

export const statusColor = {
    'in progress': 'primary',
    translated: 'warning',
    complete: 'success',
    'pre-translating': 'info',
};

